import { canv } from '@/canv/global.js'

export class shapeDatabase {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width - 2 * horizontalPadding;
        var allowedHeight = height * 3/4 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + height/4 + textPart.lines[0].textHeight + height * 3/4 / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 30;
        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.ellipse(x + width/2, y + height/8, width/2, height/8, 0, 0, 2 * Math.PI);
        canv.ctx.closePath();
        canv.ctx.moveTo(x, y + height/8);
        canv.ctx.lineTo(x, y + height * 15/16);
        canv.ctx.ellipse(x + width/2, y + height * 15/16, width/2, height/16, 0, Math.PI, 2*Math.PI, true);
        canv.ctx.lineTo(x + width, y + height/8);
        canv.ctx.ellipse(x + width/2, y + height/8, width/2, height/8, 0, 0, 2 * Math.PI);
    }

    getAvatar(color) {
        return `
        <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.35472 69.7184C0.958146 68.4025 0.81106 14.0889 1.35472 11.8639C4.75138 -2.03743 76.1389 -3.19444 80.6743 11.8639C81.3401 14.0745 80.7993 68.5684 80.6743 69.7184C79.0393 84.7605 5.88806 84.7605 1.35472 69.7184Z" fill="` + color + `"/>
        <path d="M1.35472 11.8639C0.81106 14.0889 0.958146 68.4025 1.35472 69.7184C5.88806 84.7605 79.0393 84.7605 80.6743 69.7184C80.7993 68.5684 81.3401 14.0745 80.6743 11.8639M1.35472 11.8639C4.75138 -2.03743 76.1389 -3.19444 80.6743 11.8639M1.35472 11.8639C8.15072 23.4186 73.8727 23.4186 80.6743 11.8639" stroke="black"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.11085 22.4745C0.986921 22.0633 0.940956 5.09029 1.11085 4.39498C2.17231 0.0508044 24.4809 -0.310764 25.8982 4.39498C26.1063 5.08579 25.9373 22.1151 25.8982 22.4745C25.3873 27.1752 2.52752 27.1752 1.11085 22.4745Z" fill="` + fill + `"/>
                <path d="M1.11085 4.39498C0.940956 5.09029 0.986921 22.0633 1.11085 22.4745C2.52752 27.1752 25.3873 27.1752 25.8982 22.4745C25.9373 22.1151 26.1063 5.08579 25.8982 4.39498M1.11085 4.39498C2.17231 0.0508045 24.4809 -0.310764 25.8982 4.39498M1.11085 4.39498C3.2346 8.00581 23.7727 8.00581 25.8982 4.39498" stroke="black"/>
            </svg>
        `;
    }

}
